import { green } from "@mui/material/colors";

const getStyles = (theme, { isMobile, needsLeftPadding } = {}) => ({
  headerText: {
    color: "#000"
  },
  borderBox: {
    border: "1px solid gray",
    borderRadius: 0
  },
  label: {
    fontSize: "0.8rem!important",
    lineHeight: "1rem!important",
    whiteSpace: "nowrap!important",
    textTransform: "capitalize!important",
    overflow: "hidden!important",
    textOverflow: "ellipsis!important",
    maxWidth: "calc(100% - 10px)!important",
    transform: "translate(14px, 12px) scale(1)!important"
  },
  labelNotCapitalize: {
    textTransform: "none"
  },
  labelFocused: {},
  labelShrink: {
    transform: "translate(15px, -6px) scale(0.75)!important"
  },
  errorText: {
    height: "10px",
    fontSize: "0.5rem",
    margin: theme.spacing(0.2, 0.5, 0, 1),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    textAlign: "right",
    color: theme.palette.error.main
  },
  field: {
    marginTop: `${theme.spacing(0.25)}!important`,
    marginBottom: `${theme.spacing(0.25)}!important`,

    "& .MuiSelect-outlined > .color-box": {
      right: "32px"
    },
    "& .MuiSvgIcon-root[data-testid='ArrowDropDownIcon']": {
      display: isMobile ? "none" : undefined
    },
    "& .MuiAutocomplete-clearIndicator": {
      marginRight: isMobile ? "-8px" : undefined
    },
    "& .MuiInputBase-adornedEnd": {
      paddingRight: isMobile ? "28px!important" : "12px"
    },
    "&.MuiInputBase-root > fieldset > legend": {
      fontSize: "0.6rem"
    },
    "&>.MuiInputBase-root.MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense": {
      paddingTop: theme.spacing(1.1875),
      paddingBottom: theme.spacing(1.1875)
    },
    "& .MuiPhoneNumber-flagButton": {
      width: " 34px !important",
      minWidth: "34px !important"
    },
    "& .MuiOutlinedInput-root": {
      color: `${theme.palette.text.primary}!important`,
      backgroundColor: "transparent"
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(211, 47, 47)"
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(192, 192, 192, 0.24)"
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255,255,255,0.8)"
    },
    "& .MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(192, 192, 192, 0.24)"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main
    },
    "& .MuiInputLabel-root": {
      color: "rgba(192, 192, 192, 1.24)"
    },
    "& .MuiInputLabel-root.Mui-error, & .MuiInputLabel-root.Mui-disabled": {
      color: "rgba(192, 192, 192, 1.24)"
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: "rgba(192, 192, 192, 0.24)"
    },
    "&.bi-source-field .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px"
    }
  },
  input: {
    paddingLeft: needsLeftPadding ? "36px" : undefined,
    "&::placeholder": {
      fontSize: "13px!important"
    },
    "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active": {
      transition: "background-color 500000s",
      "-webkit-text-fill-color": `${theme.palette.text.primary} !important`,
      "-webkit-box-shadow": "0 0 0 100px transparent inset"
    },
    "&::-webkit-calendar-picker-indicator": {
      ...(theme.palette.mode === "dark" && {
        filter: "invert(1)"
      })
    },
    "&.MuiInputBase-inputMultiline": {
      height: "80px!important"
    }
  },
  colorPicker: {
    display: "inline-flex",
    alignItems: "center",
    "& > div": {
      minWidth: "40px",
      minHeight: "25px",
      border: `3px solid ${theme.palette.primary.main}`,
      marginRight: theme.spacing(1.5)
    }
  },
  autoCompleteRoot: {
    width: "100%",
    "& > div > .MuiAutocomplete-inputRoot": {
      paddingLeft: "0!important"
    },
    "&  .MuiOutlinedInput-root": {
      paddingRight: `${theme.spacing(5.5)} !important`
    }
  },
  largeDropdown: {
    width: "40%",
    minWidth: "250px",
    "@media (min-width: 1536px)": {
      minWidth: "400px"
    }
  },
  checkIcon: {
    fontSize: 80,
    color: green[500],
    fill: green[500],
    width: 80,
    height: 80,
    marginBottom: theme.spacing(1)
  }
});

export default getStyles;
